import { render, staticRenderFns } from "./ToggleMySportsNotificationMutation.vue?vue&type=template&id=a272c59e"
import script from "./ToggleMySportsNotificationMutation.vue?vue&type=script&lang=ts"
export * from "./ToggleMySportsNotificationMutation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports